// extracted by mini-css-extract-plugin
export default {"color":"e0e180","color--grey":"ccf588","color--primary":"f1bf73","color--success":"a2a46e","color--danger":"d03909","notification__title":"ec5bb3","notification__notice":"a9b489"};